import {
  PackageThumbnail,
  ListeningPackageType,
  PriceDetails,
  StudentPlanStatus
} from '../common/services/package/package.model';
import UserService from '../common/services/user/user.service';
import PriceService from '../common/services/price.service';
import GoogleAnalyticsService from '../common/services/analytics/google-analytics.service';
import { AddCartEvent, Ecommerce, Product, ProductClickEvent } from '../common/services/analytics/events/dimensions';
import PackageService from '../common/services/package/package.service';
import angular = require('angular');
import { OpenYearlyContractedAction } from '../buy/yearly-contracted-info/yearly-contracted-dialog.action';
import { OpenYearlyAction } from '../buy/yearly-info/yearly-dialog.action';
import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import StudentPlanService from '../common/services/package/student.service';
import { OpenStudentNoSubAction } from '../components/student/nosub/nosub.action';
import {OpenStudentReviewingAction} from "../components/student/reviewing/reviewing.action";
import {OpenStudentRejectedAction} from "../components/student/rejected/rejected.action";
import {OpenStudentSuccessfulAction} from "../components/student/successful/successful.action";
import { OpenStudentBlockedAction } from '../components/student/blocked/blocked.action';
import { OpenStudentLimitAction } from '../components/student/limit-exceeded/limit-exceeded.action';
import { OpenStudentQuotaAction } from '../components/student/quota-exceeded/quota-exceeded.action';
import MixpanelService from '../common/services/analytics/mixpanel.service';

/* @ngInject */
export default class PacketController {
  private packet: PackageThumbnail;
  private ecommerce: Ecommerce  = new Ecommerce();


  private subscribed: boolean;
  private forSubscribe: boolean = false;
  private packetPrice: string;
  private smsInfo: string;
  public storePackage: boolean;
  private clicked = false;
  public priceDetails: PriceDetails;
  public description: string;
  public description2: string;
  public time: string;

  constructor(
    private $window,
    private $q,
    private config,
    private userService: UserService,
    private priceService: PriceService,
    private googleAnalytics: GoogleAnalyticsService,
    private packageService: PackageService,
    private actionDispatcher: ActionDispatcherService,
    private studentPlanService: StudentPlanService,
    private $state,
    private $sce,
    private $translate,
    private $rootScope,
    private i18n,
    private mixpanelService: MixpanelService
  ) {
  }

  public $onInit() {
    this.loadTranslations();
    this.time = this.priceService.getPriceInfo(this.packet);

    this.storePackage =
      this.packet &&
      this.packet.type &&
      (this.packet.type === ListeningPackageType.GOOGLEPLAY ||
        this.packet.type === ListeningPackageType.APPLESTORE);
    var _self = this;
    this.$rootScope.$on('$translateChangeSuccess', function (event, a) {
      _self.loadTranslations();
    });

  }

  public getDescContent() {
    return this.packet.descContent || this.packet.description;
  }

  public loadTranslations() {
    var translateKey =
      !this.priceDetails ||
        !this.priceDetails.pricePeriod ||
        this.priceDetails.pricePeriod === 'monthly'
        ? 'packet.period'
        : 'packet.periodYear';
    this.$translate(translateKey, this.packet).then(value => {
      this.packetPrice = this.$sce.trustAsHtml(value);
    });

    this.$translate('packet.subscriptionWithSMS', this.packet).then(value => {
      this.smsInfo = this.$sce.trustAsHtml(value);
    });
  }

  public startSubscription() {

    if(localStorage.getItem("userHasYearlyContracted")){
      this.actionDispatcher.dispatch(
        new OpenYearlyContractedAction(() => this.checkStudentPopup())
      );
    } else if(localStorage.getItem("userHasYearly")){
      this.actionDispatcher.dispatch(
        new OpenYearlyAction(() => this.checkStudentPopup())
      );
    } else{
      this.checkStudentPopup();
    }
  }
  private checkStudentPopup(){
    if(!this.packet.isStudent){
      this.goToSubscriptionPage();
    } else{
      this.studentPlanService.getUserStudentStatus().then(data => {
        switch (data.studentPlanStatus) {
          case StudentPlanStatus.APPROVED:
            this.actionDispatcher.dispatch(
              new OpenStudentSuccessfulAction(this.packet.id, data.expireDate)
            );
            break;
          case StudentPlanStatus.PENDING:
            // pending page
            this.actionDispatcher.dispatch(
              new OpenStudentReviewingAction()
            );
            break;
          case StudentPlanStatus.REJECTED:
            // rejcted
            this.actionDispatcher.dispatch(
              new OpenStudentRejectedAction()
            );
            break;
          case StudentPlanStatus.NOT_APPLIED:
            // apply form
            // after success aplication received form
            this.actionDispatcher.dispatch(
              new OpenStudentNoSubAction()
            );
            break;
          case StudentPlanStatus.BLOCKED:
            this.actionDispatcher.dispatch(
              new OpenStudentBlockedAction()
            );
            break;
          case StudentPlanStatus.LIMIT_EXCEEDED:
            this.actionDispatcher.dispatch(
              new OpenStudentLimitAction()
            );
            break;
          case StudentPlanStatus.QUOTA_EXCEEDED:
            this.actionDispatcher.dispatch(
              new OpenStudentQuotaAction()
            );
            break;
          default:
            this.actionDispatcher.dispatch(
              new OpenStudentNoSubAction()
            );
            break;
        }
      }).catch(error => {})
    }
  }

  private goToSubscriptionPage(){
    this.mixpanelService.track('Subscription Package Confirmed', { offerId: this.packet.id });

    this.ecommerce = this.googleAnalytics.setEcommerce(this.packet,'Add to Card','Satın Alabileceğim Üyelikler');
    this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new AddCartEvent)), {ecommerce : this.ecommerce,userPackage:localStorage.getItem('activePackages')}));

    this.ecommerce = this.googleAnalytics.setEcommerce(this.packet,'Click','Satın Alabileceğim Üyelikler');
    this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new ProductClickEvent)), {ecommerce:this.ecommerce,userPackage:localStorage.getItem('activePackages')}));

    this.goToBuy();
  }

  private goToBuy(){
    this.$state.go('buy', {
      packetId: this.packet.id
    });
    this.$window.scrollTo(0, 0);
  }

  public isPaycellPackage() {
    return this.packet.type === ListeningPackageType.CREDITCARD;
  }

  public openAppStore() {
    this.$window.open(
      this.config.appstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openGooglePlay() {
    this.$window.open(
      this.config.playstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public getIcon(){
    return this.packageService.getPackageIcon(this.packet);
   }
}



// WEBPACK FOOTER //
// ./src/app/packet/packet.controller.ts